//Libraries
import React from 'react';
import { connect } from 'react-redux';
//Actions
import { toggleClanStatus } from '../actions/clans';
//Material-ui
import Check from '@material-ui/icons/CheckCircle';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  checked: {
    color: '#fecd2f'
  }
});

class Status extends React.Component {

  handleClick = () => {
    const { id, value } = this.props;
    this.props.toggleClanStatus(id, value);
  }

  render() {
    const { classes } = this.props;
    return (
      <Switch
        checked={this.props.value}
        onClick={() => this.handleClick()}
        value="status"
        classes={{checked: classes.checked}}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  toggleClanStatus: (clanUid, status) => dispatch(toggleClanStatus(clanUid, status))
});

export default connect(undefined, mapDispatchToProps)(withStyles(styles)(Status));

export const Suscription = ({value}) => (
  value ? <Check color="secondary"/> : null
);